import { InvestmentStatus, TaxBenefit } from "./types";

export const INVESTMENT_STATUS_CONFIG: Record<
  InvestmentStatus,
  {
    label: string;
    backgroundColor: string;
    textColor: string;
  }
> = {
  "NEW INVESTMENT": {
    label: "NEW INVESTMENT",
    backgroundColor: "#EAEEF1",
    textColor: "#26445A",
  },
  "PRE-PRODUCT-MARKET FIT": {
    label: "PRE-PRODUCT-MARKET FIT",
    backgroundColor: "#F0F1FF",
    textColor: "#000F80",
  },
  "BREAKOUT POTENTIAL": {
    label: "BREAKOUT POTENTIAL",
    backgroundColor: "#DFFBEE",
    textColor: "#00754E",
  },
  "SUCCESS UNLIKELY": {
    label: "SUCCESS UNLIKELY",
    backgroundColor: "#FFF8DB",
    textColor: "#756800",
  },
  "WRITE-OFF": {
    label: "WRITE-OFF",
    backgroundColor: "#FFE7E0",
    textColor: "#941E00",
  },
};

export const DEFAULT_STATUS_COLORS = {
  textColor: "#6B7280",
  backgroundColor: "#F3F4F6",
};

export const TAX_BENEFIT_LABELS: Record<TaxBenefit, string> = {
  None: "None",
  EIS: "EIS",
  SEIS: "SEIS",
  "EIS/SEIS": "EIS/SEIS" as const,
};
